/* eslint-disable max-len */
import * as React from 'react';
import { SVGProps, useMemo } from 'react';
import { getIconGradientColors } from './colorUtils';

type VehicleColorableProps = SVGProps<SVGSVGElement> & {
  color?: string;
};

const VehicleColorable = ({ color, ...props }: VehicleColorableProps) => {
  const gradientId = useMemo(
    () => `vehicle_colorable_${Math.random().toString(36).substr(2, 9)}`,
    [],
  );
  const { primary, secondary } = getIconGradientColors('Vehicle', color);

  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="24" cy="24" r="24" fill={`url(#${gradientId})`} />
      <g transform="translate(9.25, 10.25)" stroke="#F7F5F8" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <path strokeWidth="1.5" d="M3.37374 8.3158H1.81923C1.22856 8.3158 0.75 7.7266 0.75 7.00001C0.75 6.27377 1.22856 5.68422 1.81923 5.68422H4.54167" />
        <path strokeWidth="1.5" d="M24.9586 5.6842H27.6809C28.2715 5.6842 28.7502 6.27375 28.7502 6.99999C28.7502 7.72659 28.2715 8.31578 27.6809 8.31578H25.8344" />
        <path strokeWidth="1.5" d="M25.5419 8.64474L23.4796 1.45077C23.3691 1.06548 23.0177 0.75 22.6985 0.75H6.66301C6.34381 0.75 5.9956 1.06697 5.88911 1.45413L3.95856 8.47636" />
        <path strokeWidth="1.4" d="M7.7501 20.75V22.8388C7.7501 24.4467 6.7101 25.75 5.42781 25.75H4.07304C2.78977 25.75 1.7501 24.4467 1.7501 22.8388V20.75" />
        <path strokeWidth="1.4" d="M27.7503 20.75V23.0654C27.7503 24.5485 26.7107 25.75 25.428 25.75H24.0729C22.7907 25.75 21.7503 24.5485 21.7503 23.0654V20.75" />
        <path strokeWidth="1.5" fillRule="evenodd" clipRule="evenodd" d="M25.6255 8.36359C25.2824 7.97585 24.6272 7.65789 24.1695 7.65789H5.03825C4.58051 7.65789 3.92508 7.97585 3.58221 8.36359L1.37365 10.8606C1.03019 11.2491 0.75 12.0455 0.75 12.6314V19.7507C0.75 20.3366 1.12407 20.8158 1.58211 20.8158H27.6259C28.0837 20.8158 28.4583 20.3366 28.4583 19.7507V12.6314C28.4583 12.0455 28.1776 11.2491 27.8344 10.8606L25.6255 8.36359Z" />
        <path strokeWidth="1.5" d="M10.6664 16.7434H18.8331" />
        <path strokeWidth="1.5" d="M2.75581 14.8947H3.53384H4.34645H6.92686C7.67747 14.8943 7.96691 14.3055 7.57518 13.5791C7.18288 12.8527 6.56027 12.2631 6.18454 12.2631H4.34645H4.27616H1.04144" />
        <path strokeWidth="1.5" d="M26.4484 14.8947H25.6709H24.8588H22.2809C21.5316 14.8947 21.2419 14.3055 21.6335 13.5791C22.0252 12.8531 22.6471 12.2631 23.0228 12.2631H24.8588H24.9293H27.8757" />
      </g>
      <defs>
        <linearGradient id={gradientId} x1="0" y1="2.5" x2="45" y2="48" gradientUnits="userSpaceOnUse">
          <stop stopColor={primary} />
          <stop offset="1" stopColor={secondary} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default VehicleColorable;
